(function() {
  'use strict';
  if (window.__ctV3Init) return;
  window.__ctV3Init = true;

  var root = document.querySelector('.ct-root');
  if (!root) return;

  // Mark hydrated after the next paint so any initial-paint transition
  // suppression (.is-hydrated guard in CSS) lifts cleanly without itself
  // causing a flash. Two rAFs is the standard pattern - first lets the
  // initial layout settle, second guarantees the browser has committed.
  requestAnimationFrame(function() {
    requestAnimationFrame(function() {
      root.classList.add('is-hydrated');
    });
  });

  var lastTrigger = null;

  // Body scroll lock - ref-counted to play nice with sibling drawers.
  // Track whether THIS drawer owns a lock so a fast open→close cannot
  // decrement a sibling modal's count before our deferred open frame runs.
  var ownsBodyLock = false;
  var openFrameToken = 0;
  function setBodyLock(lock) {
    if (lock === ownsBodyLock) return;
    var counter = window.__ssBodyLockCount || (window.__ssBodyLockCount = { n: 0 });
    if (lock) {
      ownsBodyLock = true;
      counter.n++;
      document.documentElement.style.overflow = 'hidden';
      setInertSiblings(true);
    } else {
      ownsBodyLock = false;
      counter.n = Math.max(0, counter.n - 1);
      if (counter.n === 0) {
        document.documentElement.style.overflow = '';
        setInertSiblings(false);
      }
    }
  }

  var inertSiblings = [];
  function setInertSiblings(inert) {
    if (!inert) {
      inertSiblings.forEach(function(child) { child.removeAttribute('inert'); });
      inertSiblings = [];
      return;
    }
    var children = document.body.children;
    for (var i = 0; i < children.length; i++) {
      var child = children[i];
      if (child === root || child.contains(root)) continue;
      // Skip script/style nodes - they're harmless and not focusable
      if (child.tagName === 'SCRIPT' || child.tagName === 'STYLE') continue;
      if (!child.hasAttribute('inert')) {
        child.setAttribute('inert', '');
        inertSiblings.push(child);
      }
    }
  }

  // Inline error toast - replaces alert() so failures don't blow context out
  // of the drawer. role="alert" on the markup means AT picks it up the moment
  // we un-hide it.
  var errorTimer = null;
  // GTM dataLayer events. cart_value is in DOLLARS (2dp number), cart_value_cents
  // is the raw Shopify integer. Reads cartState, so at drawer-open it is the last
  // hydrated state, not the in-flight fetch. Never throws.
  function ctTrack(name) {
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: name,
        cart_value: Math.round(cartState.total_price) / 100,
        cart_value_cents: cartState.total_price,
        currency: cartState.currency,
        item_count: cartState.item_count
      });
    } catch (e) {}
  }
  function showCartError(msg) {
    if (/failed to fetch|load failed|networkerror|network request failed/i.test(String(msg))) {
      msg = 'Could not update your basket. Check your connection and try again.';
    }
    var el = root.querySelector('[data-ct-error]');
    if (!el) {
      // Fallback only if markup is broken - should never hit in production
      alert(msg);
      return;
    }
    el.textContent = msg;
    el.hidden = false;
    if (errorTimer) clearTimeout(errorTimer);
    errorTimer = setTimeout(function() { el.hidden = true; }, 6000);
  }

  function setOpen(open) {
    // An add request may finish after the customer starts their gift message.
    // Keep that dialog interactive; opening the hidden cart would make it inert.
    if (open && document.querySelector('.gm-root[data-open="true"]')) return;
    // Idempotent: bail if we're already in the requested state. Without this,
    // repeated openCartDrawerV3() calls (e.g. cart icon double-click, or
    // an ATC firing while the drawer is already open) increment the shared
    // body-lock counter past 1, then the matching close only decrements once
    // and leaves page siblings stuck with [inert].
    var currentlyOpen = root.getAttribute('data-open') === 'true';
    if (open === currentlyOpen) return;
    if (open) {
      // remember what was focused before opening (so we can restore on close). An Add button is disabled while
      // its /cart/add is in flight, which drops focus to <body>; the PDP leaves the tapped button in
      // window.__ssCartReturnFocus so focus can still go back to it (2026-10-16).
      lastTrigger = document.activeElement;
      if ((!lastTrigger || lastTrigger === document.body) && window.__ssCartReturnFocus) lastTrigger = window.__ssCartReturnFocus;
      window.__ssCartReturnFocus = null;
      // Shopify's admin preview bar (staff sessions only) is a top-layer popover
      // over the bottom of the viewport that no z-index can beat. Measure it so
      // the drawer and gift-message footers sit clear of it (0px for shoppers).
      var pbar = document.getElementById('PBarNextFrameWrapper');
      var pbarH = pbar ? Math.round(pbar.getBoundingClientRect().height) : 0;
      document.documentElement.style.setProperty('--ss-pbar-h', pbarH + 'px');
    }
    root.setAttribute('data-open', open ? 'true' : 'false');
    root.setAttribute('aria-hidden', open ? 'false' : 'true');
    root.toggleAttribute('inert', !open);
    if (open) {
      // openCartDrawerV3 tracks after its cart refresh, so the event carries the real basket (it read 0 items
      // straight after an add); every other open path tracks here.
      if (!trackAfterRefresh) ctTrack('ss_cart_drawer_open');
      var frameToken = ++openFrameToken;
      // Defer body-lock + inert-siblings to the next frame so the slide
      // transition gets clean first paints. Doing them synchronously on the
      // same tick as data-open causes (a) iOS URL-bar collapse → 100dvh
      // recompute → mid-slide shake, and (b) a site-wide style recalc from
      // writing `inert` to every body child, which drops the first 1-2
      // frames of the transition and makes the drawer feel snappy/jittery
      // rather than a calm glide.
      requestAnimationFrame(function() {
        if (frameToken !== openFrameToken || root.getAttribute('data-open') !== 'true') return;
        setBodyLock(true);
        // Focus AFTER lock so the order is: paint slide → lock → focus.
        var closeBtn = root.querySelector('[data-ct-close]');
        if (closeBtn) closeBtn.focus({ preventScroll: true });
      });
    } else {
      openFrameToken++;
      setBodyLock(false);
      if (canFocus(lastTrigger)) {
        lastTrigger.focus({ preventScroll: true });
      } else if (root.contains(document.activeElement)) {
        // Never leave focus inside the closed (aria-hidden) dialog: screen readers then treat the aria-modal
        // drawer as still open and hide the whole page.
        document.activeElement.blur();
      }
      lastTrigger = null;
    }
  }

  function canFocus(el) {
    if (!el || el === document.body || typeof el.focus !== 'function' || !el.isConnected) return false;
    if (el.disabled || el.closest('[inert], [aria-hidden="true"]')) return false;
    return el.getClientRects().length > 0;
  }

  // ─── State + render (Task A5) ─────────────────────────────────────────
  var cartState = { items: [], total_price: 0, currency: 'AUD', item_count: 0 };
  var justAddedHandle = null;

  function fmtPrice(cents, code) {
    var sym = (code === 'GBP') ? '£' : (code === 'USD') ? 'US$' : (code === 'EUR') ? '€' : '$';
    return sym + (cents / 100).toFixed(2).replace(/\.00$/, '');
  }

  function escapeHtml(s) {
    return String(s).replace(/[&<>"']/g, function(c) {
      return { '&':'&amp;', '<':'&lt;', '>':'&gt;', '"':'&quot;', "'":'&#39;' }[c];
    });
  }

  // Escape ", \, and newlines for safe inclusion in a CSS url("...") expression.
  // JSON.stringify-slice almost works but doesn't escape backslashes the way CSS expects.
  function cssUrl(url) {
    return '"' + String(url).replace(/[\\"\n\r]/g, function(c) {
      return '\\' + c;
    }) + '"';
  }

  // Per-handle tag map - design wants an editorial mood line under the name
  // (e.g. "CALM · COMFORT · WIND DOWN"). Future: move to product metafields,
  // but for now hardcoded - list is small + stable.
  var CT_TAGS = {
    'dusk-box':      'Simple · Considered · Sweet',
    'twilight-box':  'Calm · Comfort · Wind down',
    'midnight-box':  'Generous · Bespoke · Memorable',
    'little-comforts-box': 'Simple · Considered · Sweet',
    'horizon-box':         'Calm · Comfort · Wind down',
    'gift-box-pilates-girl':  'Movement · Recovery · Care',
    'gift-box-sun-lover':     'Summer · Glow · Outside',
    'gift-box-british-treats':'Home · Sweet · Familiar',
    'gift-box-the-distance':  'Long distance · Connection · Love',
    'gift-box-for-her':       'For her · Curated · Considered',
    'gift-box-for-him':       'For him · Curated · Considered'
  };

  // Read BYO contents from the Gift Builder's "Includes" property (single
  // comma-separated string). Falls back to legacy "Item N" props for any
  // pre-existing carts. Returns a "·"-joined string for compact display.
  function extractContents(item) {
    if (!item.properties) return '';
    var stripUpcharge = function(s) { return String(s).replace(/\s*\(\+ \$[\d.]+\)\s*$/, ''); };
    var fromIncludes = function(val) {
      return String(val).split(',').map(function(s) { return stripUpcharge(s.trim()); }).filter(Boolean).join(' · ');
    };
    // properties is an array of [key, value] pairs in /cart.js responses
    if (Array.isArray(item.properties)) {
      // Prefer the new single Includes property
      for (var i = 0; i < item.properties.length; i++) {
        var p = item.properties[i];
        if (p && p[0] === 'Includes' && p[1]) return fromIncludes(p[1]);
      }
      // Legacy fallback: Item 1, Item 2, …
      var parts = [];
      item.properties.forEach(function(p) {
        if (p && p[0] && /^Item \d+$/.test(p[0])) parts.push(stripUpcharge(p[1]));
      });
      return parts.join(' · ');
    } else if (typeof item.properties === 'object') {
      if (item.properties.Includes) return fromIncludes(item.properties.Includes);
      var parts2 = [];
      Object.keys(item.properties).forEach(function(k) {
        if (/^Item \d+$/.test(k)) parts2.push(stripUpcharge(item.properties[k]));
      });
      return parts2.join(' · ');
    }
    return '';
  }

  function extractChoice(item, name) {
    var props = item.properties || {};
    if (Array.isArray(props)) {
      var pair = props.filter(function(p) { return p && p[0] === name; })[0];
      return pair ? String(pair[1] || '') : '';
    }
    return String(props[name] || '');
  }

  function renderItem(item) {
    // Robust thumb resolution - Shopify cart.js returns featured_image
    // (full obj) on real product variants; older/legacy shape exposes
    // .image directly. Either may be empty for products without media.
    // Append a size suffix (?width=200) for a tighter network footprint
    // - the thumb only renders at 76px CSS so a 200w image is plenty.
    var rawThumb = (item.featured_image && item.featured_image.url) ? item.featured_image.url : (item.image || '');
    // cart.js URLs always carry ?v=, so the width has to go on with & (it was
    // skipped, and every thumb loaded full size: Piccolo 110KB vs 7.6KB).
    var thumb = rawThumb ? rawThumb + (rawThumb.indexOf('?') === -1 ? '?' : '&') + 'width=200' : '';
    var handle = item.handle || (item.product && item.product.handle) || '';
    var tag = (item.variant_title && item.variant_title !== 'Default Title' ? item.variant_title : '') || CT_TAGS[handle] || '';
    var contents = extractContents(item);
    var printDesign = extractChoice(item, 'Print design');
    var journalColour = extractChoice(item, 'Journal colour');

    // Use <img> when we have a real URL (alt text for a11y, lazy-load for
    // perf). Empty-state fallback is a cream/parchment gradient + a small
    // gift-glyph so the slot always looks intentional rather than missing.
    var thumbHtml = thumb
      ? '<img class="ct-thumb-img" src="' + escapeHtml(thumb) + '" alt="' + escapeHtml(item.product_title || '') + '" loading="lazy" decoding="async" width="200" height="200" />'
      : '<span class="ct-thumb-fallback" aria-hidden="true">'
      +   '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round" width="24" height="24">'
      +     '<rect x="3" y="8" width="18" height="13" rx="1"/>'
      +     '<path d="M12 8v13"/>'
      +     '<path d="M3 12h18"/>'
      +     '<path d="M12 8c-2-2-5-2-5 0 0 1 1 1 5 0z"/>'
      +     '<path d="M12 8c2-2 5-2 5 0 0 1-1 1-5 0z"/>'
      +   '</svg>'
      + '</span>';

    return ''
      + '<div class="ct-item">'
      +   '<div class="ct-thumb">' + thumbHtml + '</div>'
      +   '<div>'
      +     '<div class="ct-name">' + escapeHtml(item.product_title) + '</div>'
      +     (tag ? '<div class="ct-tag">' + escapeHtml(tag).toUpperCase() + '</div>' : '')
      +     (contents ? '<div class="ct-incl">' + escapeHtml(contents) + '</div>' : '')
      +     (printDesign ? '<div class="ct-incl">Print: ' + escapeHtml(printDesign) + '</div>' : '')
      +     (journalColour ? '<div class="ct-incl">Journal: ' + escapeHtml(journalColour) + '</div>' : '')
      +     '<div class="ct-row">'
      +       '<div class="ct-qty">'
      +         '<button data-ct-qty data-key="' + item.key + '" data-delta="-1" aria-label="Decrease quantity of ' + escapeHtml(item.product_title) + '">−</button>'
      +         '<span>' + item.quantity + '</span>'
      +         '<button data-ct-qty data-key="' + item.key + '" data-delta="1" aria-label="Increase quantity of ' + escapeHtml(item.product_title) + '">+</button>'
      +       '</div>'
      +       '<button class="ct-remove" data-ct-remove data-key="' + item.key + '" aria-label="Remove ' + escapeHtml(item.product_title) + ' from cart">Remove</button>'
      +     '</div>'
      +   '</div>'
      +   '<div class="ct-price">' + fmtPrice(item.final_line_price, cartState.currency) + '</div>'
      + '</div>';
  }

  function renderDrawer() {
    if (window.SSBoxBundles) cartState = window.SSBoxBundles.displayCart(cartState);
    // Eyebrow
    var ey = root.querySelector('[data-ct-eyebrow]');
    if (ey) {
      ey.textContent = cartState.item_count + ' ' + (cartState.item_count === 1 ? 'item' : 'items')
                       + (justAddedHandle ? ' · Just added' : '');
    }

    // Just-added strip
    var addedEl = root.querySelector('[data-ct-added]');
    if (addedEl) {
      if (justAddedHandle) {
        var added = cartState.items.find(function(i) { return i.handle === justAddedHandle; });
        if (added) {
          var nameEl = root.querySelector('[data-ct-added-name]');
          if (nameEl) nameEl.textContent = added.product_title;
          // Thumbnail of what was just added (2026-07-26, mobile-only via
          // CSS). On a phone the item row below can be scrolled away, so
          // without this the confirmation is text-only and the shopper
          // never actually sees the product. Same thumb resolution as
          // renderItem(): cart.js gives featured_image on real variants,
          // legacy shape exposes .image, either can be empty.
          var thumbEl = root.querySelector('[data-ct-added-thumb]');
          if (thumbEl) {
            var addedRaw = (added.featured_image && added.featured_image.url)
              ? added.featured_image.url
              : (added.image || '');
            // Leave the slot COMPLETELY empty when there's no image - the
            // CSS shows it via :not(:empty), so any whitespace here would
            // render an empty grey square next to the tick.
            thumbEl.innerHTML = addedRaw
              ? '<img src="' + escapeHtml(addedRaw + (addedRaw.indexOf('?') === -1 ? '?' : '&') + 'width=140')
                + '" alt="" width="52" height="52" decoding="async" />'
              : '';
          }
          addedEl.hidden = false;
        } else {
          addedEl.hidden = true;
        }
      } else {
        addedEl.hidden = true;
      }
    }

    // Free delivery line (2026-09-13): every gift box ships free, so this is a
    // statement, not a progress bar. `remaining` stays defined (always 0) because
    // renderAddon() keys the crochet rail off it - 0 keeps that rail hidden, which
    // is exactly what it did for every box already over the old threshold.
    var cfg = window.__CT_V3_CFG || { gateMin: 15000, shipMin: 15000, currencySym: 'A$', currency: 'AUD', giftProductType: 'Gift Box' };
    var remaining = 0;
    var shipRow = root.querySelector('[data-ct-ship-row]');
    if (shipRow) {
      if (cartState.item_count === 0) {
        shipRow.innerHTML = '';
        shipRow.classList.remove('unlocked');
      } else {
        shipRow.innerHTML = '<span><strong>Free delivery on every gift box</strong></span><span>🚚</span>';
        shipRow.classList.add('unlocked');
      }
    }

    // Items
    var itemsEl = root.querySelector('[data-ct-items]');
    // Note: [data-ct-checkout] anchor was replaced with [data-ct-primary] button
    // in Phase B (Task B11). Selector updated to match new markup.
    var cta = root.querySelector('[data-ct-primary]');
    // Defensive: log if [data-ct-items] disappeared (e.g. external code stomped
    // the drawer markup). We previously silently skipped, leaving the user with
    // an apparently broken empty drawer + no diagnostic trail.
    if (!itemsEl) {
      console.error('[cart-v3] data-ct-items not found in DOM - drawer markup may have been stripped');
    } else if (cartState.items.length === 0) {
      // Branded empty state - a warm nudge instead of a dead end. Link stays
      // in-market via cfg.rootUrl ("" for AU, "/en-uk" for UK).
      var emptyRoot = String(cfg.rootUrl || '').replace(/\/$/, '');
      itemsEl.innerHTML =
        '<div class="ct-empty">' +
          '<div class="ct-empty-title">Nothing here yet</div>' +
          '<p class="ct-empty-body">Send a little piece of home to someone missing it.</p>' +
          '<a class="ct-empty-link" href="' + emptyRoot + '/collections/all">Browse the gift boxes</a>' +
        '</div>';
      // Anchor elements ignore [disabled] - use a class instead.
      // aria-disabled + tabindex=-1 give keyboard + AT parity with mouse.
      if (cta) {
        cta.classList.add('is-disabled');
        cta.setAttribute('aria-disabled', 'true');
        cta.setAttribute('tabindex', '-1');
      }
    } else {
      itemsEl.innerHTML = cartState.items.map(renderItem).join('');
      // Don't unconditionally re-enable here - the gate logic below may keep it disabled
      // for blocked carts. Only clear the empty-cart disable; the gate branch is authoritative.
    }

    // Subtotal
    var subEl = root.querySelector('[data-ct-subtotal]');
    if (subEl) {
      if (cartState.item_count === 0) {
        subEl.textContent = '';
      } else {
        subEl.textContent = fmtPrice(cartState.total_price, cartState.currency);
      }
    }

    // Cart-level personalisation belongs to one recipient and one gift box.
    var giftBoxCount = cartState.items.reduce(function(count, i) {
      var isBox = String(i.product_type || '').toLowerCase() === String(cfg.giftProductType || 'Gift Box').toLowerCase() ||
        !!(i.properties && i.properties._gift_box) || /^gift-box-/.test(i.handle || '') ||
        ['dusk-box', 'twilight-box', 'midnight-box', 'little-comforts-box', 'horizon-box'].indexOf(i.handle) !== -1;
      return count + (isBox ? Number(i.quantity || 0) : 0);
    }, 0);
    var wineUnconfirmed = cartState.items.some(function(i) {
      return i.handle === 'piccolo-wine' && (!i.properties || i.properties['Recipient 18+'] !== 'Confirmed');
    });
    var bundlePending = window.SSBoxBundles && window.SSBoxBundles.needsMigration(cartState);
    var blocked = cartState.item_count > 0 && (giftBoxCount !== 1 || wineUnconfirmed || bundlePending);
    var foot = root.querySelector('[data-ct-foot]');
    var helper = root.querySelector('[data-ct-gate-helper]');
    if (!helper) {
      helper = document.createElement('div');
      helper.setAttribute('data-ct-gate-helper', '');
      helper.className = 'ct-gate-helper';
      // Insert as the FIRST child of [data-ct-foot] so it appears above the CTA
      if (foot && cta) foot.insertBefore(helper, foot.firstChild);
    }
    if (blocked) {
      if (cta) {
        cta.classList.add('is-disabled');
        cta.setAttribute('aria-disabled', 'true');
        cta.setAttribute('tabindex', '-1');
      }
      helper.textContent = bundlePending
        ? 'Please remove this box and add it again with your chosen print.'
        : wineUnconfirmed
        ? 'Remove the wine and add it again, confirming you and the recipient are both 18 or over, before checkout.'
        : giftBoxCount > 1
        ? 'One gift box per order. Remove the extra box before checkout.'
        : 'A gift box is required to check out. Build your box to continue.';
      helper.hidden = false;
    } else {
      helper.hidden = true;
      // Only re-enable the CTA if the cart is non-empty (the empty-cart branch
      // above owns disabling for the empty state - don't undo that here).
      if (cta && cartState.item_count > 0) {
        cta.classList.remove('is-disabled');
        cta.removeAttribute('aria-disabled');
        cta.removeAttribute('tabindex');
      }
    }

    // ─── Phase B foot logic ─────────────────────────────────────────────────
    // Show "Add a gift message" prompt + Skip link whenever cart has items AND
    // is not blocked. (Phase B always offers the modal; Phase A had a different
    // "needsMessage" computed value - superseded.)
    var promptEl = root.querySelector('[data-ct-prompt]');
    var skipEl   = root.querySelector('[data-ct-skip]');
    var labelEl  = root.querySelector('[data-ct-primary-label]');
    var primaryBtn = root.querySelector('[data-ct-primary]');

    var showMessageCTA = cartState.item_count > 0 && !blocked;
    if (promptEl) promptEl.hidden = !showMessageCTA;
    if (skipEl)   skipEl.hidden   = !showMessageCTA;
    if (labelEl) {
      labelEl.textContent = showMessageCTA ? 'Continue · Add gift message' : 'Continue to checkout';
    }
    // Update CTA mode attribute (consumed by the click handler below)
    if (primaryBtn) {
      primaryBtn.setAttribute('data-ct-primary-mode', showMessageCTA ? 'modal' : 'checkout');
    }

    // Bind per-item handlers (the items HTML is freshly written, so we must rebind)
    if (itemsEl) {
      itemsEl.querySelectorAll('[data-ct-qty]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          var key = btn.getAttribute('data-key');
          var delta = parseInt(btn.getAttribute('data-delta'), 10);
          var item = cartState.items.find(function(i) { return i.key === key; });
          var newQty = Math.max(0, (item ? item.quantity : 0) + delta);
          updateCart(key, newQty);
        });
      });
      itemsEl.querySelectorAll('[data-ct-remove]').forEach(function(btn) {
        btn.addEventListener('click', function() {
          updateCart(btn.getAttribute('data-key'), 0);
        });
      });
    }

    renderAddon(remaining);
  }

  // Add-on rail hydration (spec 2026-07-05; lightened 2026-07-05). Reads state
  // only — never binds handlers here (those are one-time, see below).
  // CONTEXTUAL: show only while the cart holds a non-add-on item AND is still
  // under the free-ship threshold (remaining > 0), so the rail has one clear job
  // (close the gap) and gets out of the way once unlocked — reduces drawer
  // clutter. Visibility is keyed on the add-on's OWN handle (data-ct-addon-handle),
  // NOT the ship-gate product-type check. Copy stays NON-numeric: the ship bar directly above
  // already states the $ gap, so repeating it here just duplicated the message.
  // GENERALIZED 2026-07-06: now loops every [data-ct-addon] rail instead of
  // a single hardcoded slot, so the crochet companion and the art-print pilot
  // (2026-07-06) can both hydrate independently.
  function renderAddon(remaining) {
    root.querySelectorAll('[data-ct-addon]').forEach(function (el) {
      var addonHandle = el.getAttribute('data-ct-addon-handle');
      // Never offer an add-on that's already in the cart (2026-07-06).
      var alreadyInCart = cartState.items.some(function (i) { return i.handle === addonHandle; });
      if (alreadyInCart) { el.hidden = true; el.setAttribute('aria-hidden', 'true'); return; }
      // Suppress this rail if the cart already holds a box that BUNDLES this item
      // (data-ct-addon-not-with = comma list of box handles that include it).
      // Independent of the upsell/free-ship logic, so it never double-pushes a
      // crochet the box already comes with (2026-07-06).
      var notWith = el.getAttribute('data-ct-addon-not-with');
      if (notWith) {
        var excluded = notWith.split(',');
        var boxIncludesIt = cartState.items.some(function (i) { return excluded.indexOf(i.handle) !== -1; });
        if (boxIncludesIt) { el.hidden = true; el.setAttribute('aria-hidden', 'true'); return; }
      }
      var hasBox = cartState.items.some(function (i) {
        return i.handle !== addonHandle;
      });
      // Optional eligibility gate (data-ct-addon-only-with): a comma list of
      // box handles this rail should offer for. Used by the art-print pilot
      // so it only shows on boxes that DON'T already bundle a print - offering
      // someone a print they already have in the box feels tone-deaf, not
      // helpful. Rails without this attribute (the crochet slot) keep the
      // original "any box in cart" behaviour.
      var onlyWith = el.getAttribute('data-ct-addon-only-with');
      // Pure-upsell rails (data-ct-addon-only-with, e.g. the art-print pilot)
      // are NOT a free-shipping nudge, so they must show regardless of the
      // remaining-to-free-ship amount. The crochet rail keeps its original
      // "only while still short of free shipping" behaviour. Without this,
      // any box already over the $119 free-ship threshold (most single boxes)
      // would never surface the print add-on.
      var isUpsellRail = !!onlyWith;
      if (onlyWith) {
        var eligible = onlyWith.split(',');
        hasBox = cartState.items.some(function (i) {
          return eligible.indexOf(i.handle) !== -1;
        });
      }
      if (!hasBox || (!isUpsellRail && remaining <= 0)) { el.hidden = true; el.setAttribute('aria-hidden', 'true'); return; }
      el.hidden = false;
      el.setAttribute('aria-hidden', 'false');
      // Honest free-ship tie-in: only claim the unlock when ONE companion actually
      // crosses the threshold (gap <= companion price). Otherwise stay neutral so
      // we never promise free shipping on a box that's still short after adding one.
      var priceCents = parseInt(el.getAttribute('data-price-cents'), 10) || 0;
      var copy = el.querySelector('[data-ct-addon-copy]');
      if (copy) {
        // Per-rail copy override (data-ct-addon-copy-*): "companion" language
        // fits the crochet slot but reads oddly for a print, so each rail can
        // supply its own two lines. Falls back to the original crochet copy
        // when absent, so that slot's markup didn't need to change.
        var copyWin = el.getAttribute('data-ct-addon-copy-shipwin') || 'Add a little companion to the gift';
        var copyDefault = el.getAttribute('data-ct-addon-copy-default') || 'Add a little companion to the gift';
        // Only claim the free-ship unlock when there's a real gap this add-on
        // would close (remaining > 0 AND <= its price). When shipping is
        // already free (remaining <= 0), never promise an unlock - just use
        // the neutral default copy.
        var closesShipGap = priceCents && remaining > 0 && remaining <= priceCents;
        copy.textContent = closesShipGap ? copyWin : copyDefault;
      }
    });
  }

  // Serialized queue: rapid qty clicks were racing /cart/change.js requests
  // (each POST replaces the whole line - out-of-order responses corrupt state).
  // Chaining onto a single Promise guarantees server sees them in order.
  var cartReq = Promise.resolve();
  function updateCart(key, qty) {
    cartReq = cartReq.then(function() {
      return fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: qty })
      })
      .then(function(r) {
        if (!r.ok) return r.json().then(function(j) { throw new Error(j.description || 'Update failed'); });
        return r.json();
      })
      .then(function(c) {
        // This response is newer than any /cart.js read still in flight (e.g.
        // the open-drawer refresh when +/- is tapped during the slide-in), so
        // retire those reads before they repaint the old quantity (2026-10-06).
        cartRefreshSeq++;
        cartHydrated = true;
        cartState = c;
        // FIX 12: capture which control had focus BEFORE the re-render wipes
        // the items innerHTML, so we can restore focus afterwards.
        var active = document.activeElement;
        var focusInfo = null;
        if (active && active.matches && active.matches('[data-ct-qty], [data-ct-remove]')) {
          focusInfo = {
            key: active.getAttribute('data-key'),
            delta: active.getAttribute('data-delta'),
            remove: active.matches('[data-ct-remove]'),
          };
        }
        renderDrawer();
        // Keep the header cart bubble in step after qty changes and Remove -
        // Horizon's cart-icon reads detail.data.itemCount (2026-10-05).
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { source: 'cart-drawer-v3', itemCount: c.item_count } }
        }));
        syncCartBubble(c.item_count); // also the screen-reader count (2026-10-16)
        if (focusInfo) {
          var sel = focusInfo.remove
            ? '[data-ct-remove][data-key="' + focusInfo.key + '"]'
            : '[data-ct-qty][data-key="' + focusInfo.key + '"][data-delta="' + focusInfo.delta + '"]';
          var el = root.querySelector(sel);
          // the removed line's button is gone: keep focus in the drawer (on Close) rather than dropping to <body>
          if (!el) el = root.querySelector('[data-ct-close]');
          if (el) el.focus();
        }
      });
    }).catch(function(err) {
      console.error('[cart-v3] cart update failed', err);
      showCartError(err.message || 'Could not update cart - please try again.');
    });
    return cartReq;
  }

  // Add-on add — chains onto cartReq so it can't race a concurrent qty change.
  // The crochet is a real product, so after refresh the new line item, subtotal,
  // and ship bar all recompute via renderDrawer — no bespoke shipping math here.
  // `label` flags the line with the `_addon` property that the checkout gates
  // key on (see the addon-only branch in renderDrawer + ss-cart-gate.liquid).
  // WITHOUT IT the gates could be bypassed: the gift builder set `_addon` on
  // its art print, but rails added from this drawer did not, so a shopper
  // could add 4 crochets ($80, over the A$75 minimum), remove the box in the
  // drawer, and check out with add-ons and no gift box. Audit finding, 2026-07-26.
  // Underscore prefix keeps it out of customer-facing order displays.
  function addAddon(vid, label, ageConfirmed) {
    if (!vid) return cartReq;
    if (label === 'piccolo-wine' && !ageConfirmed) return Promise.resolve();
    var properties = { '_addon': label || 'Add-on' };
    if (label === 'piccolo-wine') properties['Recipient 18+'] = 'Confirmed';
    cartReq = cartReq.then(function () {
      return fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({
          items: [{ id: vid, quantity: 1, properties: properties }]
        })
      })
      .then(function (r) {
        if (!r.ok) return r.json().then(function (j) { throw new Error(j.description || 'Add failed'); });
        return r.json();
      })
      .then(function (resp) { return window.refreshCartV3({ addResp: resp }); });
    }).catch(function (err) {
      console.error('[cart-v3] addon add failed', err);
      showCartError(err.message || 'Could not add - please try again.');
    });
    return cartReq;
  }

  // Prevent older /cart.js requests from painting over newer cart state. This
  // matters when the page-load refresh is still in flight as a gift-builder ATC
  // opens the drawer.
  var cartRefreshSeq = 0;
  var cartHydrated = false;

  // Header bag count (2026-10-06). Horizon's cart-icon renders
  // detail.data.itemCount ?? 0, so a cart:update without a count (handleAtc
  // below, the gift builder) hid the bubble, and the PDP and the wine rail
  // sent nothing, leaving it stale. Every add path ends in a drawer refresh,
  // so after each real /cart.js read the drawer corrects any bubble showing
  // a different number. Compared against the DOM, not a remembered value:
  // Back from checkout can restore HTML cached while the bag was empty.
  // cart-icon.js is a module with async imports, so on a fast (cached) load
  // this can run before the element exists to hear the event: wait for it.
  function syncCartBubble(count) {
    // Horizon's cart-icon updates the visible badge but not the screen-reader text ("Total items in cart: 0"),
    // which the header cart button uses as its description. Keep its number in step (2026-10-16).
    document.querySelectorAll('#cart-bubble-text .visually-hidden').forEach(function (el) {
      el.textContent = el.textContent.replace(/\d+\s*$/, String(count));
    });
    if (!window.customElements) return;
    customElements.whenDefined('cart-icon').then(function () {
      var icons = document.querySelectorAll('cart-icon');
      var stale = Array.prototype.some.call(icons, function (i) { return i.currentCartCount !== count; });
      if (!stale) return;
      document.dispatchEvent(new CustomEvent('cart:update', {
        bubbles: true,
        detail: { data: { source: 'cart-drawer-v3', itemCount: count } }
      }));
    });
  }

  function fetchCartOnce() {
    return fetch('/cart.js', {
      headers: { 'Accept': 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store'
    })
      .then(function(r) {
        if (!r.ok) throw new Error('cart.js HTTP ' + r.status);
        return r.json();
      })
      .then(function(cart) {
        if (!window.SSBoxBundles) return cart;
        return window.SSBoxBundles.reconcile(cart).catch(function() { return cart; });
      });
  }

  window.refreshCartV3 = function(opts) {
    var seq = ++cartRefreshSeq;
    var expectItems = !!(opts && opts.expectItems);
    if (opts && opts.justAddedHandle) justAddedHandle = opts.justAddedHandle;
    // The full /cart/add.js response - used as FALLBACK if /cart.js
    // returns 0 items (Shopify session race / password-gate quirk).
    var addRespFallback = (opts && opts.addResp) ? opts.addResp : null;

    function isCurrentRefresh() {
      return seq === cartRefreshSeq;
    }

    function applyFallback(emptyCart) {
      // Build a synthetic cartState from the /cart/add.js response so the
      // drawer renders the just-added items even if /cart.js is lagging.
      if (!addRespFallback) return false;
      var fallbackItems = [];
      if (Array.isArray(addRespFallback.items)) {
        fallbackItems = addRespFallback.items;
      } else if (addRespFallback.id) {
        // Single-item add response IS the line item
        fallbackItems = [addRespFallback];
      }
      if (!fallbackItems.length) return false;
      var total = fallbackItems.reduce(function(s, i) {
        return s + ((i.final_line_price || i.line_price || i.price * (i.quantity || 1)) || 0);
      }, 0);
      cartState = {
        items: fallbackItems,
        total_price: total,
        item_count: fallbackItems.reduce(function(s, i) { return s + (i.quantity || 1); }, 0),
        currency: (emptyCart && emptyCart.currency) || cartState.currency || 'AUD'
      };
      console.warn('[cart-v3] Using /cart/add.js fallback -', fallbackItems.length, 'items');
      return true;
    }

    return fetchCartOnce()
      .then(function(c) {
        if (!isCurrentRefresh()) return;
        if (!c || typeof c !== 'object' || !Array.isArray(c.items)) {
          console.error('[cart-v3] /cart.js returned unexpected shape', c);
          applyFallback(null);
          renderDrawer();
          return;
        }
        // RACE GUARD - if we just did an ATC and the cart came back empty,
        // Shopify's session may not have committed yet. Retry once after 400ms.
        if (expectItems && c.items.length === 0) {
          console.warn('[cart-v3] /cart.js returned 0 items right after ATC - retrying in 400ms');
          return new Promise(function(resolve) { setTimeout(resolve, 400); })
            .then(fetchCartOnce)
            .then(function(c2) {
              if (!isCurrentRefresh()) return;
              if (c2 && Array.isArray(c2.items) && c2.items.length > 0) {
                cartState = c2;
                syncCartBubble(c2.item_count);
              } else {
                // FINAL FALLBACK: use the /cart/add.js response directly
                console.warn('[cart-v3] retry STILL 0 items - applying add-response fallback');
                if (!applyFallback(c2 || c)) {
                  cartState = c2 || c;
                }
              }
              renderDrawer();
            })
            .catch(function(err) {
              if (!isCurrentRefresh()) return;
              console.error('[cart-v3] retry fetch failed', err);
              if (!applyFallback(c)) cartState = c;
              renderDrawer();
            });
        }
        cartState = c;
        cartHydrated = true;
        syncCartBubble(c.item_count);
        renderDrawer();
      })
      .catch(function(err) {
        if (!isCurrentRefresh()) return;
        console.error('[cart-v3] cart fetch failed', err);
        // Try the /cart/add.js response as a last-resort fallback so the
        // drawer isn't blank when /cart.js itself errors.
        var usedFallback = false;
        try { usedFallback = applyFallback(null); } catch (e) {}
        try { renderDrawer(); } catch (e) { console.error('[cart-v3] renderDrawer threw', e); }
        // A failed fetch on a never-hydrated cart must not read "Nothing here
        // yet" - that is a claim about the cart we could not make.
        if (!usedFallback && !cartHydrated) showLoadRetry();
      })
      .then(function() {
        // Clear after first render so subsequent opens don't show stale "Just added"
        setTimeout(function() { justAddedHandle = null; }, 2000);
      });
  };

  var trackAfterRefresh = false;
  window.openCartDrawerV3 = function(opts) {
    var wasOpen = root.getAttribute('data-open') === 'true';
    trackAfterRefresh = !wasOpen;
    setOpen(true);
    var track = trackAfterRefresh;
    trackAfterRefresh = false;
    // Defer the cart refresh by one frame so the slide-in transition gets
    // clean first paints. Rewriting innerHTML for ct-items/ct-sub/ct-ship
    // during the first ~16ms of the transform causes a visible "shake" on
    // mobile - layout shifts inside the drawer compete with the GPU slide.
    // One rAF is enough: the transition is 0.65s, content is ready well
    // before the user perceives it.
    var args = opts || {};
    requestAnimationFrame(function() {
      var done = refreshCartV3IfReady(args);
      if (!track) return;
      // the open is counted once, after the basket it shows has loaded (or failed to)
      Promise.resolve(done).catch(function () {}).then(function () {
        if (root.getAttribute('data-open') === 'true') ctTrack('ss_cart_drawer_open');
      });
    });
  };
  window.closeCartDrawerV3 = function() { setOpen(false); };

  // Wrapper that always calls refreshCartV3 if defined; logs if not.
  function refreshCartV3IfReady(opts) {
    if (typeof window.refreshCartV3 === 'function') {
      try {
        return window.refreshCartV3(opts);
      } catch (err) {
        console.error('[cart-v3] refreshCartV3 threw synchronously', err);
        // Fallback: at least show the empty-state render
        renderDrawer();
      }
    } else {
      console.error('[cart-v3] refreshCartV3 not defined - rendering empty state');
      renderDrawer();
    }
  }

  // Initial render - paint the drawer's empty state on page load.
  // This ensures the markup looks correct even if a customer clicks the cart
  // icon before any ATC, and protects against refreshCartV3 failing silently.
  // Also fetches /cart.js so the cart state is hydrated before the drawer is opened.
  refreshCartV3IfReady({});

  // Safety net: if 3s after a refresh the items container is STILL empty (no
  // ct-item rows, no ct-empty notice) /cart.js hung or never resolved. Show a
  // retry that calls refreshCartV3 and re-arms this same timer, so the worst
  // case is a button, never a permanent "Loading".
  function showLoadRetry() {
    var itemsEl = root.querySelector('[data-ct-items]');
    if (!itemsEl) return;
    itemsEl.innerHTML = '<div class="ct-empty"><button type="button" class="ct-retry" data-ct-retry>Couldn’t load your cart - tap to retry</button></div>';
    var retry = itemsEl.querySelector('[data-ct-retry]');
    if (retry) {
      retry.addEventListener('click', function() {
        itemsEl.innerHTML = '<div class="ct-empty" data-ct-loading>Loading your cart…</div>';
        armLoadFallback();
        refreshCartV3IfReady({});
      });
    }
  }
  var loadFallbackTimer = null;
  function armLoadFallback() {
    if (loadFallbackTimer) clearTimeout(loadFallbackTimer);
    loadFallbackTimer = setTimeout(function() {
      loadFallbackTimer = null;
      var itemsEl = root.querySelector('[data-ct-items]');
      if (itemsEl && (itemsEl.innerHTML.trim() === '' || itemsEl.querySelector('[data-ct-loading]'))) {
        console.warn('[cart-v3] items container still empty 3s after refresh - showing retry');
        showLoadRetry();
      }
    }, 3000);
  }
  armLoadFallback();

  // Close handlers
  var closeBtn = root.querySelector('[data-ct-close]');
  if (closeBtn) closeBtn.addEventListener('click', window.closeCartDrawerV3);

  var backdrop = root.querySelector('[data-ct-backdrop]');
  if (backdrop) backdrop.addEventListener('click', window.closeCartDrawerV3);

  // ── Bulletproof close (X) ────────────────────────────────────────────────
  // On mobile the drawer is full-width (100vw) so there is NO backdrop to tap -
  // the X is the only visible way to close (besides Esc / browser-back, which
  // touch users don't reach for). So if anything steals the tap on the X, the
  // drawer feels stuck. That happens on certain pages because .ct-root shares
  // z-index 12000 with full-viewport fixed siblings (gm-root, ss-pfi-*, painted
  // AFTER the drawer in DOM) and sits below others (product-detail-sheet 99999,
  // #ssfm-modal 100000, gift-media, region/cookie/email app embeds). The normal
  // guards - pointer-events:none + setInertSiblings() - neutralise siblings that
  // exist WHEN the drawer opens, but a layer injected or shown AFTER open (a
  // late app-embed popup, a re-shown sticky bar) escapes them and can paint over
  // the X corner; a page script can also swallow the bubbling click.
  //
  // The direct closeBtn handler above relies on the tap reaching the button and
  // bubbling. This is the belt-and-braces guarantee: a CAPTURE-phase listener on
  // document fires before the event can reach any overlay target, and we hit-test
  // the tap GEOMETRICALLY against the close button's rect instead of trusting
  // event.target. So the X closes the drawer even when something is layered over
  // it or eating the bubble. Keyboard activation (clientX/Y at 0 or off the rect)
  // falls through to the direct handler above - no double-handling.
  // Higher-priority surfaces own a tap only when the event actually lands
  // inside that visible surface. A global state-marker query used to disable
  // the cart X while any other modal was stale or finishing its close animation.
  var CT_HIGHER_OVERLAY_SELECTOR = [
    '.ss-detail-overlay.open',
    '#ss-detail-sheet[aria-hidden="false"]',
    '.c1-swv:not([hidden])',
    '.c1-pa-lb:not([hidden])',
    '.gm-root[data-open="true"]',
    '#ssfm-modal.is-open',
    '.pd-root[aria-hidden="false"]',
    '.gd-root[aria-hidden="false"]',
    '.search-modal__content[open]',
    '[data-modal-open="true"]'
  ].join(',');

  function ctOverlayIsVisible(el) {
    if (!el || el === root || root.contains(el)) return false;
    var style = window.getComputedStyle(el);
    if (style.display === 'none' || style.visibility === 'hidden' || style.pointerEvents === 'none') return false;
    if (parseFloat(style.opacity || '1') === 0) return false;
    var rect = el.getBoundingClientRect();
    return rect.width > 0 && rect.height > 0;
  }

  function ctEventOwnedByHigherOverlay(e) {
    var target = e && e.target;
    if (!target || target.nodeType !== 1 || !target.closest) return false;
    return ctOverlayIsVisible(target.closest(CT_HIGHER_OVERLAY_SELECTOR));
  }

  function ctHigherOverlayVisible() {
    var overlays = document.querySelectorAll(CT_HIGHER_OVERLAY_SELECTOR);
    for (var i = 0; i < overlays.length; i++) {
      if (ctOverlayIsVisible(overlays[i])) return true;
    }
    return false;
  }
  // Geometric hit-test: is (x,y) on the close button? Trusts the button's live
  // rect, NOT event.target - so it fires even when an invisible layer is painted
  // over the X. Padded 6px so an edge tap still lands.
  function ctCloseHitAt(x, y) {
    if (root.getAttribute('data-open') !== 'true') return false;
    var btn = root.querySelector('.ct-close[data-ct-close]');
    if (!btn) return false;
    var r = btn.getBoundingClientRect();
    if (!(r.width > 0 && r.height > 0)) return false;
    var pad = 6;
    return x >= r.left - pad && x <= r.right + pad &&
           y >= r.top - pad && y <= r.bottom + pad;
  }
  var ctDismissedPointer = null;
  function ctForceClose(e) {
    // Closing on pointerup hides the drawer before its following click.
    // Consume that click so it cannot hit the header cart trigger underneath.
    if (e && (e.type === 'pointerup' || e.type === 'touchend')) {
      var point = e.changedTouches ? e.changedTouches[0] : e;
      if (point) ctDismissedPointer = { x: point.clientX, y: point.clientY, until: Date.now() + 500 };
    }
    if (e) {
      e.preventDefault();
      e.stopPropagation();
      if (e.stopImmediatePropagation) e.stopImmediatePropagation();
    }
    window.closeCartDrawerV3();
  }
  // ── WHY window-capture (not document, not bubble) ────────────────────────
  // The X is the ONLY visible dismiss on mobile (full-width drawer, no backdrop
  // tap target). If anything steals the tap the drawer feels stuck. Window is
  // the FIRST node in the capture path - earlier than document and every element
  // - so this runs before any overlay's own handler and before the previous
  // document-capture net could be beaten by a window/earlier listener. Multiple
  // event types cover every way a "tap" can reach us; closeCartDrawerV3 is
  // idempotent (setOpen bails if already closed) so overlapping fires are safe.
  //
  // Pointer path requires BOTH pointerdown AND pointerup inside the X rect, so a
  // swipe/scroll that merely ENDS over the X never triggers a close.
  // Only the PRIMARY pointer may set or consume the flag. On a full-width
  // mobile drawer the X sits in the top corner, so a one-handed thumb reach
  // flattens the palm edge onto the screen: that second pointerdown used to
  // overwrite ctDownOnClose with a miss, and multi-touch also suppresses the
  // synthetic click - every close path dead for that grip, every time.
  var ctDownOnClose = false;
  window.addEventListener('pointerdown', function(e) {
    if (e.isPrimary === false) return;
    ctDownOnClose = !ctEventOwnedByHigherOverlay(e) && ctCloseHitAt(e.clientX, e.clientY);
  }, true);
  window.addEventListener('pointercancel', function(e) {
    if (e.isPrimary === false) return;
    ctDownOnClose = false;
  }, true);
  window.addEventListener('pointerup', function(e) {
    if (e.isPrimary === false) return;
    if (!ctDownOnClose) return;
    ctDownOnClose = false;
    if (ctEventOwnedByHigherOverlay(e)) return;
    if (!ctCloseHitAt(e.clientX, e.clientY)) return;
    ctForceClose(e);
  }, true);
  // click fallback (covers keyboard Enter/Space → synthetic click at 0,0, which
  // misses the rect and correctly falls through to the direct button handler;
  // also covers environments without Pointer Events).
  window.addEventListener('click', function(e) {
    var dismissed = ctDismissedPointer;
    ctDismissedPointer = null;
    if (dismissed && e.detail !== 0 && Date.now() <= dismissed.until &&
        Math.abs(e.clientX - dismissed.x) <= 12 && Math.abs(e.clientY - dismissed.y) <= 12) {
      e.preventDefault();
      e.stopImmediatePropagation();
      return;
    }
    if (ctEventOwnedByHigherOverlay(e)) return;
    if (!ctCloseHitAt(e.clientX, e.clientY)) return;
    ctForceClose(e);
  }, true);
  // touchend fallback: if a page/overlay preventDefaults touchstart the synthetic
  // click is never generated. passive:false so our preventDefault is honoured.
  window.addEventListener('touchend', function(e) {
    if (ctEventOwnedByHigherOverlay(e)) return;
    // Every lifted touch, not just [0]: when palm and thumb lift together the
    // X-tap can arrive at any index of changedTouches.
    var ts = e.changedTouches || [];
    for (var ti = 0; ti < ts.length; ti++) {
      if (ctCloseHitAt(ts[ti].clientX, ts[ti].clientY)) { ctForceClose(e); return; }
    }
  }, { capture: true, passive: false });

  // Primary CTA click handler - opens modal OR navigates to /checkout based on mode
  var primaryBtnGlobal = root.querySelector('[data-ct-primary]');
  if (primaryBtnGlobal) {
    primaryBtnGlobal.addEventListener('click', function(e) {
      if (this.getAttribute('aria-disabled') === 'true') {
        e.preventDefault();
        return;
      }
      var mode = this.getAttribute('data-ct-primary-mode') || 'checkout';
      if (mode === 'modal' && typeof window.openGiftMessageModal === 'function') {
        ctTrack('ss_gift_modal_open');
        // Close drawer first so modal can take focus cleanly
        window.closeCartDrawerV3();
        // Open modal on next tick
        setTimeout(function() { window.openGiftMessageModal(); }, 0);
      } else {
        // Fallback: direct to checkout
        window.location.href = (window.__SS_ROUTES && window.__SS_ROUTES.checkout) || '/checkout';
      }
    });
  }

  // Add-on rail wiring — bound ONCE (elements are static in the Liquid markup).
  // Swatch select tracks the chosen variant in a closure AND names it in the
  // button ("Add Avocado · $20") so the CTA confirms what's being added rather
  // than leading with a cold price. Price is market-aware (read from data-price,
  // rendered by a money filter in the Liquid).
  // GENERALIZED 2026-07-06: was a single querySelector for the crochet-only
  // slot; now loops every [data-ct-addon] rail (crochet + art print pilot) so
  // each gets its own independent chip/button state via its own closure.
  root.querySelectorAll('[data-ct-addon]').forEach(function (addonRoot) {
    var age = addonRoot.querySelector('[data-ct-wine-age]');
    var ageError = addonRoot.querySelector('[data-ct-wine-age-error]');
    var addonChips = addonRoot.querySelectorAll('[data-ct-addon-sw]');
    var addonAddBtn = addonRoot.querySelector('[data-ct-addon-add]');
    var addonLabel = addonRoot.querySelector('[data-ct-addon-label]');
    var addonPrice = addonAddBtn ? (addonAddBtn.getAttribute('data-price') || '') : '';
    var addonSelVid = addonChips.length ? addonChips[0].getAttribute('data-vid') : null;
    function setAddonLabel(chip) {
      if (!addonLabel) return;
      var name = chip ? (chip.getAttribute('aria-label') || '') : '';
      addonLabel.textContent = name ? ('Add ' + name + ' · ' + addonPrice) : ('Add ' + addonPrice);
    }
    if (addonChips.length) setAddonLabel(addonChips[0]);
    addonChips.forEach(function (chip) {
      chip.addEventListener('click', function () {
        addonSelVid = chip.getAttribute('data-vid');
        // Keep the 18+ tick: it confirms the people's ages, not the bottle.
        // Clearing it here meant tick -> pick Rose -> Add always failed (2026-10-06).
        if (ageError) ageError.hidden = true;
        addonChips.forEach(function (c) {
          var sel = c === chip;
          c.classList.toggle('is-sel', sel);
          c.setAttribute('aria-checked', sel ? 'true' : 'false');
        });
        setAddonLabel(chip);
      });
    });
    function setAgeError(show) {
      if (!age || !ageError) return;
      ageError.hidden = !show;
      if (show) {
        if (!ageError.id) ageError.id = 'ct-wine-age-error-' + Math.random().toString(36).slice(2, 8);
        age.setAttribute('aria-invalid', 'true');
        age.setAttribute('aria-describedby', ageError.id);
      } else {
        age.removeAttribute('aria-invalid');
        age.removeAttribute('aria-describedby');
      }
    }
    // a refused add's error must not still be showing the next time the drawer opens (2026-10-16)
    new MutationObserver(function () { if (root.getAttribute('data-open') !== 'true') setAgeError(false); })
      .observe(root, { attributes: true, attributeFilter: ['data-open'] });
    if (age && ageError) {
      age.addEventListener('change', function () { if (age.checked) setAgeError(false); });
    }
    if (addonAddBtn) {
      addonAddBtn.addEventListener('click', function () {
        if (addonAddBtn.getAttribute('aria-busy') === 'true' || !addonSelVid) return;
        if (age && !age.checked) {
          setAgeError(true);
          age.focus();
          return;
        }
        addonAddBtn.setAttribute('aria-busy', 'true');
        setAgeError(false);
        // Label from the rail's own handle so each add-on is identifiable on
        // the order ("art-print-monthly-edition" vs "emotional-support-crochet").
        var addonHandle = addonRoot.getAttribute('data-ct-addon-handle') || 'Add-on';
        addAddon(addonSelVid, addonHandle, !!(age && age.checked)).then(function () {
          addonAddBtn.setAttribute('aria-busy', 'false');
          // Once the wine is in, a later re-add (after Remove) asks again.
          if (age && cartState.items.some(function (i) { return i.handle === addonHandle; })) age.checked = false;
          // the rail hides itself once its add-on is in the basket: never leave focus inside a hidden rail
          if (addonRoot.hidden && addonRoot.contains(document.activeElement)) {
            var cb = root.querySelector('[data-ct-close]');
            if (cb) cb.focus({ preventScroll: true });
          }
        });
      });
    }
  });

  // Skip link - clear any stale gift-message attributes, then go to checkout.
  // Hardcoded /checkout (rather than routes.checkout_url) because it works
  // across all markets and never resolves to an empty string.
  var skipBtnGlobal = root.querySelector('[data-ct-skip]');
  if (skipBtnGlobal) {
    skipBtnGlobal.addEventListener('click', function(e) {
      e.preventDefault();
      e.stopPropagation();
      var btn = this;
      if (btn.getAttribute('aria-busy') === 'true') return;
      btn.setAttribute('aria-busy', 'true');
      ctTrack('ss_checkout_skip_card');

      // Force-zero all personalisation keys so Shopify Flow does NOT fire
      // a recipient email/SMS from stale values left by an earlier attempt.
      var blank = {
        'Recipient first name': '', 'Recipient last name': '',
        'Recipient phone': '',      'Recipient email': '',
        'Recipient relationship': '','Occasion': '',
        'Message tone': '',         'Gift message': '',
        'Digital message': '',      'Hint enabled': '',
        'Unlock hint': '',          'Unlock answer': '',
        'Unlock fallback': '',      'Unlock media URL': '',
        'Delivery speed': '',       'Notify email': '',
        'Notify SMS': '',           'Gift to': '',
        'Skip gift message': 'true'
      };

      fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ attributes: blank }),
        credentials: 'same-origin'
      })
      .catch(function(err) { console.warn('[cart-v3] skip attr-clear failed', err); })
      .then(function() { window.location.assign('/checkout'); });
    });
    // Back from checkout restores this page from the bfcache with Skip still
    // busy, so it ignored every tap until a reload.
    window.addEventListener('pageshow', function(e) {
      if (e.persisted) skipBtnGlobal.removeAttribute('aria-busy');
    });
  }

  var continueLink = root.querySelector('[data-ct-continue-shopping]');
  if (continueLink) {
    continueLink.addEventListener('click', function(e) {
      e.preventDefault();
      window.closeCartDrawerV3();
    });
  }

  // Esc closes - guarded against higher-priority sibling drawers/modals
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Escape') return;
    if (root.getAttribute('data-open') !== 'true') return;
    // Let the genuinely visible top surface consume Escape first.
    if (ctHigherOverlayVisible()) return;
    window.closeCartDrawerV3();
    e.stopPropagation();
  });

  // Focus trap - Tab cycles within the drawer when open.
  // WCAG SC 2.4.3 + aria-modal requirement.
  document.addEventListener('keydown', function(e) {
    if (e.key !== 'Tab') return;
    if (root.getAttribute('data-open') !== 'true') return;
    var focusables = root.querySelectorAll(
      'a[href]:not([tabindex="-1"]), button:not([disabled]):not([tabindex="-1"]), input:not([disabled]), [tabindex="0"], [contenteditable="true"]'
    );
    var visible = Array.prototype.filter.call(focusables, function(el) {
      return el.offsetParent !== null;
    });
    if (visible.length === 0) return;
    var first = visible[0];
    var last  = visible[visible.length - 1];
    if (e.shiftKey && document.activeElement === first) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  // ─── ATC interception ──────────────────────────────────────────────────
  // Every product-add on the site should open this drawer instead of:
  //   (a) navigating to /cart, or
  //   (b) showing Horizon's native cart-drawer-component / fly-to-cart toast.
  //
  // Three delegated listeners, all in CAPTURE phase so they run BEFORE
  // Horizon's product-form-component#handleSubmit (which calls
  // event.preventDefault + its own fetch to /cart/add.js).
  //
  // cart-drawer-v3 is the single ATC surface across the site (Task A8
  // deleted personalisation-drawer + gift-drawer). The defensive
  // `.pd-root`/`.gd-root` selectors below in the Esc handler and form
  // closest() check are now harmless dead matches - kept intentionally
  // so the drawer is robust against any future re-introduction of those
  // surfaces (e.g. Phase B personalisation modal).

  /**
   * POST the form to /cart/add.js, then open the drawer with the new line item.
   * Surfaces any Shopify error (sold-out variant, exceeded quantity, etc.)
   * directly to the user - they need to know why the add failed.
   * @param {HTMLFormElement} form
   */
  function handleAtc(form) {
    var fd = new FormData(form);
    // Tracking selector covers Horizon's `<button name="add">` and the
    // legacy `<button type="submit">` shape - both still present in theme.
    var addBtn = form.querySelector('button[name="add"], [type="submit"]');
    if (addBtn) addBtn.classList.add('is-loading');

    fetch('/cart/add.js', {
      method: 'POST',
      body: fd,
      headers: { 'Accept': 'application/json' }
    })
      .then(function(r) {
        if (!r.ok) {
          // Parse Shopify's error body so we can surface a real message
          return r.json().then(function(j) { throw new Error(j.description || j.message || 'Add to cart failed'); });
        }
        return r.json();
      })
      .then(function(addResp) {
        // /cart/add.js returns two shapes:
        //   - single add: { id, handle, title, ... }     (the line item directly)
        //   - multi add:  { items: [{ handle, ... }, ...] }
        var justAddedHandle = null;
        if (addResp) {
          if (addResp.handle) {
            justAddedHandle = addResp.handle;
          } else if (addResp.items && addResp.items[0] && addResp.items[0].handle) {
            justAddedHandle = addResp.items[0].handle;
          }
        }
        // Re-emit Horizon's cart:update event so the header cart bubble + any
        // other native listeners see the change (we stopImmediatePropagation'd
        // Horizon's own emission earlier in the capture phase).
        document.dispatchEvent(new CustomEvent('cart:update', {
          bubbles: true,
          detail: { data: { source: 'cart-drawer-v3', addResp: addResp } }
        }));
        // FIX 8: open drawer immediately so the slide animation starts ASAP;
        // openCartDrawerV3 internally calls refreshCartV3 which hydrates the
        // cart in the background. Perceived latency drops ~150-300ms vs waiting
        // for /cart.js to resolve serially first.
        window.openCartDrawerV3({ justAddedHandle: justAddedHandle, expectItems: true, addResp: addResp });
      })
      .catch(function(err) {
        console.error('[cart-v3] ATC failed', err);
        // Open the drawer so the error toast inside it is visible - otherwise
        // showCartError writes to a hidden element the user never sees.
        if (root.getAttribute('data-open') !== 'true') setOpen(true);
        showCartError((err && err.message) || 'Could not add to cart - please try again.');
      })
      .finally(function() {
        if (addBtn) addBtn.classList.remove('is-loading');
      });
  }

  // NOTE: stopImmediatePropagation is intentional - keeps Horizon's native
  // cart-drawer-component from firing on the same event after we intercept.
  // 1) Delegated SUBMIT - primary path. Every product-form Liquid tag
  // renders `<form action="/cart/add" ...>` so we filter on the action attr.
  document.addEventListener('submit', function(e) {
    var form = e.target;
    if (!form || form.tagName !== 'FORM') return;
    var actionAttr = form.getAttribute('action') || '';
    if (actionAttr.indexOf('/cart/add') === -1) return;

    // Don't double-intercept forms inside the cart drawer itself (e.g. any
    // future qty controls). The `#pd-root` / `.pd-root` checks are dead
    // matches post-Task-A8 but kept as defensive scaffolding for any
    // future personalisation modal (Phase B).
    if (form.closest('.ct-root, #pd-root, .pd-root')) return;

    e.preventDefault();
    e.stopImmediatePropagation();
    handleAtc(form);
  }, true);  // CAPTURE - runs before Horizon's bubble-phase handleSubmit

  // 1b) Delegated CLICK on add-to-cart button - PARALLEL/BACKUP path.
  //
  // Horizon's <add-to-cart-component> button carries `on:click="/handleClick"`.
  // In recent Horizon builds the click handler can short-circuit before native
  // form submit fires (e.g. when fly-to-cart animation eats the event, or
  // when the inner button has no associated <form> ancestor in some quick-add
  // surfaces). If our submit listener above never catches the ATC, the item
  // still lands in cart via Horizon's own fetch - but our drawer's hydration
  // path (refreshCartV3 via openCartDrawerV3 from the cart-icon click) races
  // ahead of Horizon's /cart/add.js completing and we get an empty drawer.
  //
  // This click interceptor catches the *button* click in capture phase,
  // walks up to the enclosing form, and runs our own handleAtc. We then
  // stopImmediatePropagation so Horizon's handleClick + native submit can't
  // double-fire. preventDefault on the button click cancels the implicit
  // submit (per HTML spec: cancelling click on a type=submit button cancels
  // the submission).
  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest) return;
    var btn = e.target.closest([
      'add-to-cart-component button[type="submit"]',
      'add-to-cart-component button[name="add"]',
      'button[data-testid="add-to-cart-button"]'
    ].join(','));
    if (!btn) return;
    // Skip non-primary clicks / modifier clicks - let them through unchanged.
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    // Skip if button is disabled or marked busy.
    if (btn.disabled || btn.getAttribute('aria-disabled') === 'true') return;
    var form = btn.closest('form');
    if (!form) return;
    var actionAttr = form.getAttribute('action') || '';
    if (actionAttr.indexOf('/cart/add') === -1) return;
    // Don't double-intercept forms inside the cart drawer itself.
    if (form.closest('.ct-root, #pd-root, .pd-root')) return;
    // Validate the form first - Horizon also gates on checkValidity().
    if (typeof form.checkValidity === 'function' && !form.checkValidity()) return;
    e.preventDefault();
    e.stopImmediatePropagation();
    handleAtc(form);
  }, true);  // CAPTURE - runs before Horizon's product-form handleClick/handleSubmit

  // 2) Delegated CLICK on cart icon → open drawer (don't navigate to /cart,
  // don't open Horizon's native cart-drawer-component).
  //
  // Selector covers ALL header-actions.liquid render branches:
  //   - settings.cart_type == 'page'    → `<a href="{{ routes.cart_url }}" class="action__cart">`
  //   - settings.cart_type == 'drawer'  → `<cart-drawer-component> <button on:click="/open" data-testid="cart-drawer-trigger">`
  // Plus footer "view cart" links and any future `[data-cart-trigger]` el.
  //
  // The `cart-icon, cart-icon *` part catches clicks landing on the inner
  // SVG span (event.target inside the custom element) without us needing
  // to know whether the parent is an <a> or a <button>.
  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest) return;
    var trig = e.target.closest([
      '[data-cart-trigger]',
      '[data-testid="cart-drawer-trigger"]',
      'a[href$="/cart"]',
      'a[href*="/cart?"]',
      'a.action__cart',
      'cart-drawer-component > button',
      'cart-icon'  // the custom element wrapping the icon SVG in both branches
    ].join(','));
    if (!trig) return;
    // Respect modifier-key clicks → still open in new tab / context menu.
    if (e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    // If user is already on /cart, let the normal page work - they may be
    // editing the full cart UI deliberately.
    if (window.location.pathname.replace(/\/$/, '') === '/cart') return;
    // Don't intercept the cart icon if it lives inside a product card's
    // "fly to cart" or inside our own drawer.
    if (trig.closest('.ct-root, fly-to-cart')) return;
    e.preventDefault();
    e.stopImmediatePropagation();  // stop Horizon's cart-drawer-component#open
    window.openCartDrawerV3();
  }, true);

  // NOTE on Horizon's <add-to-cart-component>: its handleClick (see
  // assets/product-form.js line 70) ONLY runs animations - the actual
  // /cart/add fetch happens in product-form-component#handleSubmit
  // (line 280), which is a normal form-submit handler. Our capture-phase
  // submit listener above catches that submit event before Horizon does.
  // No click-level interceptor needed for the standard Horizon ATC path.
  //
  // The Gift Builder (sections/gift-builder.liquid#gbConfirmOrder, line
  // 6014) does its OWN fetch('/cart/add.js') without a form submit. That
  // path is NOT intercepted here by design - Task B13 will modify the
  // builder to call window.openCartDrawerV3() after its own fetch.

  // ── /cart redirect handoff ─────────────────────────────────────────────
  // `templates/cart.json` redirects /cart visitors to / with a sessionStorage
  // bump (`ss_open_cart_after_nav`), so the legacy /cart page no longer
  // dead-ends. When that bump is present on this page load, auto-open the
  // drawer once Horizon's cart bridge is ready.
  try {
    if (sessionStorage.getItem('ss_open_cart_after_nav') === 'open-cart') {
      sessionStorage.removeItem('ss_open_cart_after_nav');
      // Defer past the initial refreshCartV3 → fetch('/cart.js') round-trip
      // so the drawer's item list is populated before it slides in. 350ms
      // matches the typical /cart.js latency on a warm CDN; longer = safer,
      // shorter risks an empty-state flash. Falls back to opening regardless
      // if openCartDrawerV3 exists - empty-state UX is acceptable, blank
      // page is not.
      setTimeout(function () {
        if (typeof window.openCartDrawerV3 === 'function') window.openCartDrawerV3();
      }, 350);
    }
  } catch (e) { /* sessionStorage unavailable - silently skip */ }
})();
